import ErrorPage from "@/components/errors/ErrorPage";
import GroupSection from "@/components/group/GroupSection";
import { Skeleton } from "@/components/ui/skeleton";
import { getCollections, iCollection } from "@/services/collection";
import { getGroup, iGroup } from "@/services/groups";
import { selectUser } from "@/store/userSlice";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

export default function GroupPage() {
  const { groupId } = useParams();

  const [isLoadingGroup, setIsLoadingGroup] = useState(false);
  const [isLoadingCollections, setIsLoadingCollections] = useState(false);
  const [group, setGroup] = useState<iGroup>();
  const [collections, setCollections] = useState<iCollection[]>([]);

  const user = useSelector(selectUser);

  const { t } = useTranslation();

  const loadGroup = async () => {
    if (!groupId) return;
    setIsLoadingGroup(true);
    try {
      const temp_group = await getGroup(groupId);
      setGroup(temp_group);
    } catch (error) {
      console.log(error);
    }
    setIsLoadingGroup(false);
  };

  const loadCollections = async () => {
    setIsLoadingCollections(true);
    try {
      const collections = await getCollections({
        page: 1,
        size: 500,
        query: JSON.stringify({ groupId: groupId }),
      });
      setCollections(collections.data);
    } catch (error) {
      console.log(error);
    }
    setIsLoadingCollections(false);
  };

  useEffect(() => {
    if (!user) return;
    loadGroup();
    loadCollections();
  }, [groupId, user]);

  if (isLoadingGroup) return <Skeleton />;
  if (isLoadingCollections) return <Skeleton />;

  if (!group) return <ErrorPage message={t("group.not_found")} />;

  return (
    <>
      <GroupSection
        onRefresh={() => {
          loadGroup();
          loadCollections();
        }}
        group={group}
        collections={collections}
        key={group._id}
      />
    </>
  );
}
